import { plugin as engagementPlugin } from '@amplitude/engagement-browser';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';
import {
  AmplitudeBrowserTrackingClient,
  createEventsCore,
} from '@apollo-frontend/tracking-core';

import Config from 'src/lib/config';
import { isCypressEnvironment } from 'src/lib/isCypressUser';

import { AmplitudeApiKey } from './amplitudeApiKey';
import type { TrackingEvents } from './generated/taxonomy';

const { amplitudeOptions } = Config.settings;

/**
 * The single Amplitude instance for the main Studio app. Product events,
 * identify, Session Replay, and Guides & Surveys all share its device and
 * session IDs.
 */
export const amplitudeClient = AmplitudeBrowserTrackingClient.create({
  ...amplitudeOptions,
  apiKey: AmplitudeApiKey[amplitudeOptions.environment],
  product: 'studio',
  client: {
    configuration: {
      ...amplitudeOptions.client?.configuration,
      appVersion: Config.gitCommitHash,
    },
  },
  // Plugins must be added before init; Cypress runs never record Session Replay.
  plugins: [
    ...(isCypressEnvironment() ? [] : [sessionReplayPlugin()]),
    engagementPlugin(),
  ],
});

export const events = createEventsCore<TrackingEvents>(() => amplitudeClient);
